module.exports = __webpack_public_path__ + "static/media/ic-season-summer.e49ad699.svg";